import axios from 'axios'
const state = {
    salersgroups: [],
    permissions: [],
    tableOptions: {
        tableHeaders: [],
        tableData: [],
        accessTableData: [],
        loading: false,
        tableMeta: {
            total: 10,
            page: 1,
        },
    }
};
const getters = {
    getSalersGroups(state) {
        return state.salersgroups
    },
    getTableOptions(state) {
        return state.tableOptions
    },
    getPermissions(state) {
        return state.permissions
    }
};

const mutations = {
    setSalersGroups(state, salersgroups) {
        state.salersgroups = salersgroups
    },
    setPermissions(state, permissions) {
        state.permissions = permissions
    },
    setLoading(state, status) {
        state.tableOptions.loading = status
    },
    setTableData(state, tableInfo) {
        state.tableOptions.tableHeaders = tableInfo.tableHeaders
        state.tableOptions.tableData = tableInfo.tableData
        state.tableOptions.accessTableData = tableInfo.accessTableData
        state.tableOptions.tableMeta.total = tableInfo.tableMeta.total
        state.tableOptions.tableMeta.page = tableInfo.tableMeta.page
    }
};

const actions = {
    async fetchSalersGroups({ commit }, queryParams) {
        try {
            commit('setLoading', true)
            let params = {};
            for (let key in queryParams) {
                if (queryParams[key]) {
                    params[key] = queryParams[key];
                }
            }
            if(!queryParams.paginated) params.paginated = queryParams.paginated;
            const response = await axios.get("/pos/cashier-group", {
                params,
            });
            commit('setSalersGroups', response.data.data)
            // commit('setTableData', {
            //     tableHeaders: [
            //         "id",
            //         "name",
            //         "Mailing Responsibility",
            //         "Sales Invoice",
            //         "settings",
            //     ],
            //     tableData: response.data.data,
            //     accessTableData: [
            //         ["id"],
            //         ["name"],
            //         ["user","name"],
            //         ["invoice_type","name"],
            //     ],
            //     tableMeta: {
            //         total: response.data.meta.total,
            //         page: response.data.meta.current_page,
            //     },
            // })
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    async fetchPermissions({ commit }) {
        try {
            commit('setLoading', true)
            const response = await axios.get("/pos/cashier-group/permissions");
            commit('setPermissions', response.data.data)
        } catch (err) {
            console.log('err', err);
        } finally {
            commit('setLoading', false)
        }
    },
    
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}